'use es6';

import * as AppUninstallableReasons from '../constants/installability/AppUninstallableReasons';
import AppInstallability from '../records/AppInstallability';
export const getAppUninstallableReason = appInstallability => {
  if (!(appInstallability instanceof AppInstallability)) {
    throw new Error(`Expected AppInstallability instance, received ${typeof appInstallability}`);
  }
  const {
    installed,
    incompatibleHubInstalls,
    incompatibleHubUserInstalls,
    missingHubUserRoles,
    missingHubScopes,
    missingHubScopeGroups
  } = appInstallability;
  if (installed) {
    return AppUninstallableReasons.ALREADY_INSTALLED;
  } else if (missingHubUserRoles.size && !missingHubScopes.size) {
    return AppUninstallableReasons.MISSING_USER_PERMISSIONS;
  } else if (missingHubScopes.size || missingHubScopeGroups.size) {
    return AppUninstallableReasons.MISSING_HUB_SCOPES;
  } else if (incompatibleHubInstalls.size || incompatibleHubUserInstalls.size) {
    return AppUninstallableReasons.INCOMPATIBLE_INSTALLS;
  }
  return null;
};